function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Assert from '../util/Assert';
var GraphComponent = /*#__PURE__*/function () {
  function GraphComponent() {
    _classCallCheck(this, GraphComponent);
    GraphComponent.constructor_.apply(this, arguments);
  }
  return _createClass(GraphComponent, [{
    key: "setVisited",
    value: function setVisited(isVisited) {
      this._isVisited = isVisited;
    }
  }, {
    key: "setInResult",
    value: function setInResult(isInResult) {
      this._isInResult = isInResult;
    }
  }, {
    key: "isCovered",
    value: function isCovered() {
      return this._isCovered;
    }
  }, {
    key: "isCoveredSet",
    value: function isCoveredSet() {
      return this._isCoveredSet;
    }
  }, {
    key: "setLabel",
    value: function setLabel(label) {
      this._label = label;
    }
  }, {
    key: "getLabel",
    value: function getLabel() {
      return this._label;
    }
  }, {
    key: "setCovered",
    value: function setCovered(isCovered) {
      this._isCovered = isCovered;
      this._isCoveredSet = true;
    }
  }, {
    key: "updateIM",
    value: function updateIM(im) {
      Assert.isTrue(this._label.getGeometryCount() >= 2, 'found partial label');
      this.computeIM(im);
    }
  }, {
    key: "isInResult",
    value: function isInResult() {
      return this._isInResult;
    }
  }, {
    key: "isVisited",
    value: function isVisited() {
      return this._isVisited;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return GraphComponent;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);
}();
export { GraphComponent as default };
GraphComponent.constructor_ = function () {
  this._label = null;
  this._isInResult = false;
  this._isCovered = false;
  this._isCoveredSet = false;
  this._isVisited = false;
  if (arguments.length === 0) {} else if (arguments.length === 1) {
    var label = arguments[0];
    this._label = label;
  }
};